<template>
  <div style="background: #fff">
    <div class="issue-status is-pay-box is_replay">
      <i class="icon icon-time"></i>
      <h3>{{chargestatus(orderData.charge_status,orderData.status)}}</h3>
    </div>
    <div class="prices">
      <div class="price-item">
        <span>订单编号：</span>
        <span class="font-65">{{orderData.order_sn}}</span>
      </div>
      <div class="price-item">
        <span>就诊人：</span>
        <span class="font-65">{{orderData.patient_name}}</span>
      </div>
      <div class="price-item">
        <span>医生：</span>
        <span class="font-65">{{orderData.zname}}</span>
      </div>
      <div class="price-item">
        <span>就诊时间：</span>
        <span class="font-65">{{odate(orderData.start_time*1000)}} {{otime(orderData.start_time*1000)}}~{{otime(orderData.end_time*1000)}}</span>
      </div>
      <div class="price-item">
        <span>就诊医院：</span>
        <span class="font-65">{{orderData.hospital_name}}</span>
      </div>
      <div class="price-item">
        <span>订单类型：</span>
        <span class="font-65" v-if="orderData.visit_type==2">会诊</span>
        <span class="font-65" v-else>预约挂号({{orderData.type==1?'门诊':'视频'}})</span>
      </div>
      <div class="price-item">
        <span>订单金额：</span>
        <span class="font-65">￥{{orderData.charge_amount/100}}</span>
      </div>
      <div class="price-item">
        <span>下单时间：</span>
        <span class="font-65">{{odatetime(orderData.created_at*1000)}}</span>
      </div>
      <div class="price-item" v-if="orderData.charge_status == 4">
        <span>失效时间：</span>
        <span class="font-65">{{odatetime((orderData.created_at+(15*60))*1000)}}</span>
      </div>
    </div>
    <div class="pay-btn-box" v-if="chargestatus(orderData.charge_status,orderData.status) == '待支付'">
      <div class="pay-tip" v-if="orderData && orderData.pay_method !=2">请在{{osends(daoTime)}}内完成支付，超时订单自动取消</div>
      <div class="pay-btn" @click="guahao">立即支付</div>
    </div>
  </div>
</template>
<script>
import http from "../../request/http";

const pingpp = require("pingpp-js");
export default {
  name: "guahao",
  data() {
    return {
      orderData:{

      },
      daoTime:"",
      daoFun:null
    };
  },
  components: {},
  computed: {
    chargestatus(){
      return function(status,status2){
        let text = "";
        if(status == 1 && status2 == 1){
            text = "待支付";
        }else{
          //1待就诊2已到诊3已取消4已失效 5已就诊
          switch(status2){
            case "1":
              text = '待就诊';
              break;
            case "2":
              text = '已到诊';
              break;
            case "3":
              text = '已取消';
              break;
            case "4":
              text = '已失效';
              break;
            case "5":
              text = '已就诊'
            default:
              text = '';
          }
        }
        return text;
      }
    },
    odate(){
      return function(times){
        var date=new Date(parseInt(times));
        var year=date.getFullYear();
        var mon = date.getMonth()+1;
        var day = date.getDate();
        return year+'年'+(mon<10?'0'+mon:mon)+'月'+(day<10?'0'+day:day)+'日';
      }
    },
    otime(){
      return function(times){
        var date=new Date(parseInt(times));
        var hou = date.getHours();
        var min = date.getMinutes();
        return (hou<10?'0'+hou:hou)+':'+(min<10?'0'+min:min);
      }
    },
    odatetime(){
       return function(times){
        var date=new Date(parseInt(times));
        var year=date.getFullYear();
        var mon = date.getMonth()+1;
        var day = date.getDate();
        var hou = date.getHours();
        var min = date.getMinutes();
        return year+'-'+(mon<10?'0'+mon:mon)+'-'+(day<10?'0'+day:day)+' '+(hou<10?'0'+hou:hou)+':'+(min<10?'0'+min:min);
      }
    },
    osends(){
      return function(times){
        let hours = parseInt(times % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        let minutes = parseInt(times % (1000 * 60 * 60) / (1000 * 60));
        let seconds = parseInt(times % (1000 * 60) / 1000);
        return (minutes<10?'0'+minutes:minutes)+'分'+(seconds<10?'0'+seconds:seconds)+'秒';
      }
    }
  },
  mounted() {
    this.orderdetail();
  },
  methods: {
    orderdetail(){
      http.post('/api/wap/visit/orderdetail',{
        id: this.$route.query.orderid
      }).then((res) => {
        console.log(res)
        this.orderData = res.data;
        if(res.data.charge_status==2){
          this.$router.push('/guahaoSuccess?orderid='+this.$route.query.orderid);
        }else{
          let now = new Date().getTime();
          // 如果不是到院支付
          if(this.orderData && this.orderData.pay_method !=2){
            this.daoTime = ((res.data.created_at*1000)+(15*60*1000))-now;
            if(this.daoTime >= 0){
              this.daoFun = setInterval(()=>{
                if(this.daoTime - 1000 <= 0){
                  this.daoTime = 0;
                  clearInterval(this.daoFun)
                }else{
                  this.daoTime = this.daoTime - 1000;
                }
              },1000)
            }else{
              this.daoTime = 0;
            }
          }
        }
      })
    },
    guahao() {
      http.post('/api/wap/visit/pay',{
        order_id: this.$route.query.orderid,
        currency: "cny",
        channel: "wx_pub",
      }).then((res) => {
        console.log(res);
        pingpp.createPayment(res.data, (result, err) => {
          if (result == "success") {
            // 只有微信公众账号 (wx_pub)、微信小程序 (wx_lite)、QQ 公众号 (qpay_pub)、支付宝口碑 (alipay_qr)
            // 支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL。
            this.paying = false;
            this.$toast.center("支付成功");
            this.$router.push("/guahaoSuccess?orderid="+this.$route.query.orderid);
          } else if (result == "fail") {
            // data 不正确或者微信公众账号/微信小程序/QQ 公众号/支付宝口碑支付失败时会在此处返回
            this.$toast.center("支付异常，请重试");
            this.paying = false;
          } else if (result == "cancel") {
            // 微信公众账号、微信小程序、QQ 公众号、支付宝口碑支付取消支付
            console.log("wx_pub cancel");
            this.$toast.center("取消支付");
            this.paying = false;
          }
        });
      });
    },
  },
};
</script>
<style scoped>
@import "guahao.css";
</style>



// WEBPACK FOOTER //
// src/pages/guahao/guahao.vue